import Color from 'color'
import createRoom from './createRoom'
import fetchRooms from './fetchRooms'
import updateRoom from './updateRoom'
import deleteRoom from './deleteRoom'

export interface IRoom {
  id: string
  position?: number

  name: string
  type: RoomType
  description: string

  coords_lat?: string
  coords_lng?: string
  airbnb_mapping: boolean
  roomSize: string
  additionalBeds: string
  singleBed: string
  doubleBed: string
  ical_token: string
  size?: any
  additionalEquipment?: any
  id_country?: number
  street?: string
  post_code?: string
  city?: string
  serviceCleaning?: Date | undefined
  serviceBedding?: Date | undefined
  serviceTowels?: Date | undefined
  serviceCleaningStage?: RoomServiceType
  airbnb?: boolean
  customColor?: Color
  isDeleted?: boolean

  booking: boolean
  iCalendar: boolean
  title: string
  iCalendarSync: number
  bookingRoomId?: string

  widget: number

  modifiedAt?: Date
  modified?: number
}

export enum RoomServiceType {
  Waiting = '0',
  Cleaning = '1',
  Cleaned = '2',
}

export enum RoomType {
  Room = '1',
  Apartament = '2',
  House = '3',
  Studio = '4',
  Bungalow = '5',
  Camper = '6',
  Villa = '7',
  Tent = '8',
  Lodge = '9',
  Bed = '10',
  Boat = '11',
  BigHouse = '12',
}

export { createRoom, fetchRooms, updateRoom, deleteRoom }
